import { render } from "./AddOpportunityCommentComponent.vue?vue&type=template&id=597f04aa"
import script from "./AddOpportunityCommentComponent.vue?vue&type=script&lang=js"
export * from "./AddOpportunityCommentComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__